import axios from 'axios';
import { getMicroserviceGWF } from '../helpers/helpers';

export const listBanners = () => ({
  type: 'GET_BANNERS',
  payload: axios.get(
    `${getMicroserviceGWF('sponsor-portal')}public/marketplace/banners/B2B`
  ),
});
